import React, { useEffect } from "react";

function Overlay({ children, isOpen, setIsOpen }) {
  function closeOnEscapeKey(event) {
    if (event.keyCode === 27 && isOpen) {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    window.addEventListener("keydown", closeOnEscapeKey);
    return () => {
      window.removeEventListener("keydown", closeOnEscapeKey);
    };
  });

  useEffect(() => {
    document
      .querySelectorAll("body, html")
      .forEach((e) =>
        e.classList[isOpen ? "add" : "remove"]("overflow-hidden")
      );
  }, [isOpen]);

  return (
    <div
      className={`
    fixed z-50 block bg-white/95 backdrop-blur-md transition duration-300 ease-in-out
    ${isOpen ? `inset-0 opacity-100` : `opacity-0 pointer-events-none`}
    `}
    >
      <div
        className={`flex flex-col h-full max-h-full
      ${isOpen ? `block` : `hidden`}
      `}
      >
        <div className="fixed top-0 right-0 mt-4 mr-4">
          <button
            className={`text-gray-900 focus:outline-none select-none
            transition duration-300 ease-out
            ${isOpen ? `opacity-100 block` : `opacity-0 hidden`}
            `}
            onClick={() => setIsOpen(false)}
          >
            <svg
              className="hi-outline hi-x inline-block w-8 h-8 text-gray-900"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>{" "}
          </button>
        </div>
        <div className="flex flex-grow overflow-hidden">{children}</div>
      </div>
    </div>
  );
}

export default Overlay;
